var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading28_container"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"circle"}),_c('div',{staticClass:"circle"}),_c('div',{staticClass:"shadow"}),_c('div',{staticClass:"shadow"}),_c('div',{staticClass:"shadow"})])])
}]

export { render, staticRenderFns }